import React from "react";
import Frame from "../../images/Frame.png";
import Logo from "../../images/sedona_log.png";

const LeftPanel = () => {
  return (
    <React.Fragment>
      <img className="logoImg" src={Logo} alt="" />
      <div className="d-flex justify-content-center align-items-center leftPanel-container">
        <img className="frame" src={Frame} alt="" />
      </div>
    </React.Fragment>
  );
};

export default LeftPanel;
